export const FETCH_CUSTOM_PAGES_REQUEST = "FETCH_CUSTOM_PAGES_REQUEST";
export const FETCH_CUSTOM_PAGES_SUCCESS = "FETCH_CUSTOM_PAGES_SUCCESS";
export const RECEIVE_CUSTOM_PAGE = "RECEIVE_CUSTOM_PAGE";
